
import actions from './employeeAction.js'

export default {
  namespaced: true,
  // state,
  // mutations,
  actions,
  // getters
}

